module.exports = __webpack_public_path__ + "img/play-recording.3b833a6a.svg";